module.exports = __webpack_public_path__ + "media/images/frontend/linkedin-1cca26be3f51808e3110b87cfddb8b93.svg";